import { render } from "./getContacts.vue?vue&type=template&id=e65cde88&scoped=true"
import script from "./getContacts.vue?vue&type=script&lang=js"
export * from "./getContacts.vue?vue&type=script&lang=js"

import "./getContacts.vue?vue&type=style&index=0&id=e65cde88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e65cde88"]])

export default __exports__